import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { CircleLoader } from '@components/Loaders';

import { formatDate } from '@utils/format';

import { SyncWrapper, TextDiv, WrapperDiv } from './UpdatedTimestamp.style';

const messages = defineMessages({
  updating: {
    id: 'lastUpdate.updating',
    defaultMessage: 'Updating...',
  },
  lastUpdate: {
    id: 'lastUpdate.lastUpdate',
    defaultMessage: 'Last Update: ',
  },
  neverUpdated: {
    id: 'lastUpdate.neverUpdated',
    defaultMessage: 'Never Updated',
  },
});

function UpdateRecordTimestamp({
  lastUpdate,
  loading = false,
}: {
  lastUpdate?: Date | null;
  loading?: boolean;
}) {
  const { formatMessage } = useIntl();

  function updatingText() {
    if (loading) {
      return formatMessage(messages.updating);
    }
    if (lastUpdate) {
      return `${formatMessage(messages.lastUpdate)} ${formatDate({
        date: lastUpdate,
      })}`;
    }
    return formatMessage(messages.neverUpdated);
  }

  return (
    <SyncWrapper>
      <WrapperDiv>
        <TextDiv>{updatingText()}</TextDiv>
      </WrapperDiv>
      <CircleLoader loading={loading} size="20px" />
    </SyncWrapper>
  );
}

export default UpdateRecordTimestamp;
